<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import ClickOut from '../../../../utils/directives/clickout'
  import Service from '../../../../domain/tasks-detro/services/tasks'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import {forEach as _forEach, debounce, isArray} from 'lodash'
  import BtnAcoesTask from './BtnAcaoListaTasks'
  import {Status, StatusTitle} from '../../../../domain/grv/helpers/GrvStatus'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
  import {getLabel} from '../../../../domain/grv/helpers/tipos-grv'
  import {SITUACOES_TASK_LABEL, SITUACAO_EXECUTADA} from '../../../../domain/tasks-detro/helpers/task-status'

  export default {
    components: {
      PopupViewer,
      BtnAcoesTask,
      UPagination
    },
    nome: 'detro-tasks-list',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        isLoading: false,
        arrayData: null,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: '',
          dataRegistro: null,
          dataExecutado: null,
          // status: null,
          situacao: null,
          descending: true,
          sortBy: 'id',
          dataRegistro1: '',
          dataRegistro2: '',
          dataExecutado1: '',
          dataExecutado2: ''
        },
        patios: null,
        prevent: {},
        SITUACOES_TASK_LABEL
      }
    },
    computed: {
      noData () {
        if (this.arrayData === null) return false
        return this.arrayData.length === 0
      },
      Status () {
        return Status
      },
      iconSortingDirection () {
        return this.filtros.descending ? 'up' : 'down'
      }
    },
    mounted () {
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    methods: {
      loading (v) {
        this.isLoading = !!v
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },
      open (id, status) {
        /* if (status > 0) {
          this.$router.push({name: 'grv.visualizar.patio', params: {id: id}})
        } else {
          this.$router.push({name: 'grv.visualizar', params: {id: id}})
        } */
      },

      loadData (limit, page, filtros) {
        this.arrayData = null
        this.isLoading = true
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.arrayData = response.data.result
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.loadData(this.pagination.limit, page, this.montaFiltros())
      },

      checkAll (o) {
        this.$nextTick(() => {
          let ca = this.checkedAll
          let _vm = this
          console.log(ca)
          if (ca === true) {
            console.log(ca, o.length)
            this.checkeds = o.length
          } else {
            this.checkeds = 0
          }
          _forEach(o, (item, key) => {
            _vm.$set(this.arrayData, key, Object.assign({}, this.arrayData[key], {selected: ca})) // Analisar desempenho
            // item.selected = ca
            // console.log(item)
          })
        })
      },
      lazyCheck: function (l) {
        this.$nextTick(() => {
          if (l.selected) {
            this.checkeds += 1
          } else {
            this.checkeds += -1
          }

          this.checkedAll = this.checkeds >= this.arrayData.length
        })
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        for (let key in filtros) {
          if (filtros.hasOwnProperty(key)) {
            const val = filtros[key]
            if (val !== null) {
              mount += `&${key}=${val}`
            }
          }
        }
        return mount
      },
      sortResults (sortKey) {
        this.filtros.descending = !this.filtros.descending
        this.filtros.sortBy = sortKey
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },
      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      reloadData () {
        let filters = null

        // TODO: REFATORAR
        if (this.filtros.dataRegistro === 'Periodo') {
          filters = {...this.filtros}
          let {dataRegistro1, dataRegistro2} = filters
          if (!dataRegistro1 || !dataRegistro2) return
        } else {
          this.filtros.dataRegistro1 = ''
          this.filtros.dataRegistro2 = ''
        }

        if (this.filtros.dataExecutado === 'Periodo') {
          filters = {...this.filtros}
          let {dataExecutado1, dataExecutado2} = filters
          if (!dataExecutado1 || !dataExecutado2) return
        } else {
          this.filtros.dataExecutado1 = ''
          this.filtros.dataExecutado2 = ''
        }
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros(filters))
      },
      StatusTitle (s, t) {
        return StatusTitle(s, t)
      },
      formataInformacoesGrv (log) {
        const infoCache = log.informacoesGrvCache

        if (infoCache && Object.keys(infoCache).length > 0) {
          return [
            `Contrato: ${infoCache.contrato || '-'}`,
            `Placa: ${infoCache.placa || '-'}`,
            `Placa Original: ${infoCache.placaOriginal || '-'}`,
            `GRV: ${infoCache.grv || '-'}`
          ].join('\n')
        }

        if (log.entity === 'grv') {
          return [
            `Contrato: ${getLabel(+log.tipoProcesso) || '-'}`,
            `Placa: ${log.placa || '-'}`,
            `Placa Original: ${log.placaOriginal || '-'}`,
            `GRV: ${log.numero || '-'}`
          ].join('\n')
        }

        return '---'
      },
      forcarExecucaoTask ({id, executed}) {
        if (+executed === SITUACAO_EXECUTADA) {
          alert('Esta task já foi executada.')
          return
        }
        if (!confirm(`Executar task #${id}?`)) return

        this.$loaderOverlay.open(`Executando task #${id}, aguarde...`)

        Service.forcarExecucaoTask(id)
          .then(response => {
            console.log(response)
            alert(response.data)
            this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
            this.$loaderOverlay.hide()
          })
          .catch(error => {
            alert(this.printError(error.data.errors))
            this.$loaderOverlay.hide()
          })
      },
      deleteTask ({id, executed}) {
        if (+executed === SITUACAO_EXECUTADA) {
          alert('Esta task já foi executada. Não é possível excluí-la.')
          return
        }
        if (!confirm(`Excluir a task #${id}?`)) return

        this.$loaderOverlay.open(`Removendo task #${id}, aguarde...`)

        Service.deleteTask(id)
          .then(response => {
            console.log(response)
            alert(`Task #${id} excluída.`)
            this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
            this.$loaderOverlay.hide()
          })
          .catch(error => {
            alert(this.printError(error.data.errors))
            this.$loaderOverlay.hide()
          })
      },
      printError (err) {
        if (isArray(err)) {
          return err[0]
        }
        return err
      }
    },
    watch: {
      filtros: function (val) {
        console.log('Mudou')
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Tasks DETRO <span class="badge">{{this.pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted"></small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs"></div>
                </div>
              </div>

              <!-- Importação aqui se necessário -->

            </div>

            <div class="wrapper-sm">
              <div class="panel panel-default wrapper-sm" id="filters_main">
                <div class="row m-l-xs m-r-xs" id="filters">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="title_filter " for="filtroDataRegistro">Data de Registro</label>
                      <select id="filtroDataRegistro" @change="reloadData" v-model="filtros.dataRegistro" class="form-control">

                        <option :value="null">
                          Qualquer data
                        </option>

                        <option :value="'Hoje'">Hoje</option>
                        <option :value="'7dias'">Últimos 7 dias</option>
                        <option :value="'Mes'">Este mês</option>
                        <option :value="'Ano'">Este ano</option>
                        <option :value="'Periodo'">Período</option>

                      </select>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="title_filter " for="filtroDataExecucao">Data de Execução</label>
                      <select id="filtroDataExecucao" @change="reloadData" v-model="filtros.dataExecutado" class="form-control">

                        <option :value="null">
                          Qualquer data
                        </option>

                        <option :value="'Hoje'">Hoje</option>
                        <option :value="'7dias'">Últimos 7 dias</option>
                        <option :value="'Mes'">Este mês</option>
                        <option :value="'Ano'">Este ano</option>
                        <option :value="'Periodo'">Período</option>

                      </select>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="form-group">
                      <label class="title_filter " for="filtroStatus">Situação</label>
                      <select v-model="filtros.situacao" @change="reloadData" id="filtroStatus" class="form-control">

                        <option :value="null">
                          Todos
                        </option>

                        <option v-for="(situacao, key) in SITUACOES_TASK_LABEL" :value="key">
                          {{situacao.label}}
                        </option>

                      </select>
                    </div>
                  </div>

                </div>
                <div class="row m-l-xs m-r-xs" v-if="filtros.dataRegistro === 'Periodo'">
                  <div class="col-md-6 filtros-periodo-datas form-group">
                    <span class="m-l m-r">Registrado em </span>
                    <input id="filtroDataRegistro1" placeholder="dd/mm/yyyy"
                           v-model="filtros.dataRegistro1"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <span class="m-l m-r">até</span>
                    <input id="filtroDataRegistro2" placeholder="dd/mm/yyyy"
                           v-model="filtros.dataRegistro2"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <button class="btn btn-sm btn-info m-l" @click="reloadData" :disabled="!filtros.dataRegistro1 || !filtros.dataRegistro2">Pesquisar</button>
                  </div>
                </div>

                <div class="row m-l-xs m-r-xs" v-if="filtros.dataExecutado === 'Periodo'">
                  <div class="col-md-6 filtros-periodo-datas form-group">
                    <span class="m-l m-r">Executado em </span>
                    <input id="filtroDataExecutado1" placeholder="dd/mm/yyyy"
                           v-model="filtros.dataExecutado1"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <span class="m-l m-r">até</span>
                    <input id="filtroDataExecutado2" placeholder="dd/mm/yyyy"
                           v-model="filtros.dataExecutado2"
                           v-mask="'##/##/####'" type="text" class="form-control"/>
                    <button class="btn btn-sm btn-info m-l" @click="reloadData" :disabled="!filtros.dataExecutado1 || !filtros.dataExecutado2">Pesquisar</button>
                  </div>
                </div>

              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-8 m-b-xs">
                </div>
                <div class="col-sm-4">
                  <div class="input-group">
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar: ID Task / Nº GRV / Placa / Chassi">
                    <span class="input-group-btn">
                                <button class="btn btn-sm btn-default" type="button">Buscar</button>
                            </span>
                  </div>
                </div>
              </div>
              <div class="table-responsive" style="overflow-x: unset">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th style="width:20px;">
                      <label class="i-checks m-b-none">
                        <input type="checkbox" @change="checkAll(arrayData)" v-model="checkedAll" tabindex="0"
                               aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </th>
                    <th style="cursor: pointer" @click="sortResults('id')">
                      ID Task <i v-show="filtros.sortBy === 'id'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th>Tipo</th>
                    <th>Informações GRV</th>
                    <th style="cursor: pointer" @click="sortResults('dateAdded')">
                      Data de Registro <i v-show="filtros.sortBy === 'dateAdded'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th style="cursor: pointer" @click="sortResults('dateExecuted')">
                      Data de Execução <i v-show="filtros.sortBy === 'dateExecuted'" :class="`fa fa-caret-${iconSortingDirection}`"></i>
                    </th>
                    <th>Status</th>
                    <th>Opções</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="20px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                  </tr>
                  <!-- ngRepeat: pessoa in pessoas| limitTo: 10 -->
                  <tr v-for="data in arrayData">
                    <td class="v-middle">
                      <label class="i-checks m-b-none">
                        <input v-on:click.stop="lazyCheck(data)" type="checkbox" name="post[]"
                               v-model="data.selected"
                               tabindex="0" aria-checked="false"
                               aria-invalid="false"><i></i>
                      </label>
                    </td>
                    <td class="v-middle" @click="open(data.id, data.status)" role="button" tabindex="0">{{ data.id }}</td>
                    <td class="v-middle" @click="open(data.id, data.status)" role="button" tabindex="0" style="white-space: pre-wrap; text-align: left">{{data.description}}</td>
                    <td class="v-middle" @click="open(data.id, data.status)" role="button" tabindex="0" style="white-space: pre-wrap; text-align: left">{{formataInformacoesGrv(data)}}</td>
                    <td class="v-middle" @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.dateAdded ? moment(data.dateAdded.date).format('DD/MM/YYYY HH:mm:ss') : '-----' }}
                    </td>
                    <td class="v-middle" @click="open(data.id, data.status)" role="button" tabindex="0">
                      {{ data.dateExecuted ? moment(data.dateExecuted.date).format('DD/MM/YYYY HH:mm:ss') : '-----' }}
                    </td>
                    <td class="v-middle" @click="open(data.id, data.status)" role="button" tabindex="0">
                      <span :class="`alert-${SITUACOES_TASK_LABEL[+data.executed].class}`" style="padding:5px">{{SITUACOES_TASK_LABEL[+data.executed].label}}</span>
                    </td>
                    <td class="v-middle" role="button" tabindex="0">
                      <btn-acoes-task
                        :task="data"
                        @forcarExecucaoTask="forcarExecucaoTask"
                        @deleteTask="deleteTask"
                      />
                    </td>
                  </tr><!-- end ngRepeat: pessoa in pessoas| limitTo: 10 -->

                  <tr v-if="noData">
                    <td colspan="4">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-4 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{
                      pagination.totalPages
                      }}
                    </small>
                  </div>
                  <div class="col-sm-4 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage"
                                  :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>

    </div>
  </transition>
</template>

<style scoped>
  .filtros-periodo-datas {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// ListaTasks.vue?9b21c148